import {
  Component,
  ElementRef,
  Input,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import {
  Wellhead,
  WellheadAttachment,
  WellheadBottomConnectorType,
  WellheadHydraulic,
  WellheadSectionName,
  WellheadTopConnectorType,
} from 'src/app/interfaces/wellhead';
import { Image } from 'src/app/interfaces/image';
import { DialogService } from 'src/app/services/dialog.service';
import { HandoverService } from 'src/app/services/handover.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ImageService } from 'src/app/services/image.service';
import { MatDialog } from '@angular/material/dialog';
import { HandoverImageComponent } from 'src/app/components/handover-image/handover-image.component';
import { UserService } from 'src/app/services/user.service';
import {
  HANDOVER_TYPE_HO1_ID,
  HANDOVER_TYPE_HOAC_ID,
  HANDOVER_TYPE_HOEC_ID,
  PERMISSION_ENGINEERING_COMPLETION,
} from 'src/app/handover-constants';
import { HttpErrorResponse } from '@angular/common/http';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Handover } from 'src/app/interfaces/handover';
import { PendingChanges } from '../shared/pending-changes.class';
import { environment } from 'src/environments/environment';
import {
  HandoverRelation,
  RelatedHandover,
} from 'src/app/interfaces/handover-relation';

@Component({
  selector: 'app-handover-detail-wellhead',
  templateUrl: './handover-detail-wellhead.component.html',
  styleUrls: ['./handover-detail-wellhead.component.scss'],
  standalone: false,
})
export class HandoverDetailWellheadComponent
  extends PendingChanges
  implements OnInit
{
  @Input() handover: Handover | undefined;
  @Input() wellId: string | undefined;
  @Input() readOnlyContent!: boolean;
  @Input() handoverRelation: HandoverRelation | undefined;

  wellheads: Wellhead[] = [];
  originalWellheads: Wellhead[] = [];
  wellheadSectionNames: WellheadSectionName[] = [];
  wellheadTopConnectorTypes: WellheadTopConnectorType[] = [];
  wellheadBottomConnectorTypes: WellheadBottomConnectorType[] = [];
  isLoading = false;
  isDisabled: boolean[] = [];
  hydraulicHasPendingChanges = false;
  schemeHasPendingChanges = false;
  displayedColumns = [
    'sectionNameId',
    'topHub',
    'topFlange',
    'topConnectorTypeId',
    'spacer',
    'bottomHub',
    'bottomFlange',
    'bottomConnectorTypeId',
    'flangeManufacturer',
    'actions',
  ];
  wellheadImages: Image[] = [];
  imageLimit = 6;
  qtyImageRequired = 1;
  isLoadingImages = false;
  hideFooter = true;
  canUserEditImages = false;
  displayWellheadHydraulic = false;
  fileLimit = 2;
  buttonFile = false;
  uploadfile = false;
  wellheadAttachment: any;
  dhoApiUrl = `${environment.urlBackend}/dhoapi`;
  ReadOnlyContentWellheadImages = false;
  relatedHandover: RelatedHandover = {} as RelatedHandover;
  isHOLOC = false;

  wellheadHydraulic: WellheadHydraulic = {
    masterValve: undefined,
    valveOverMaster: undefined,
  };

  formHydraulic: UntypedFormGroup;

  constructor(
    public handoverService: HandoverService,
    public imageService: ImageService,
    public dialogService: DialogService,
    public notificationService: NotificationService,
    private userService: UserService,
    public dialog: MatDialog,
    private formBuilder: UntypedFormBuilder
  ) {
    super();
    this.formHydraulic = this.formBuilder.group({
      masterValve: ['', [Validators.pattern('^[0-9]+$')]],
      valveOverMaster: ['', [Validators.pattern('^[0-9]+$')]],
    });

    this.formHydraulic.valueChanges.subscribe(() => {
      this.onChangeWellheadHydraulic();
    });
  }

  ngOnInit(): void {
    // Comentado provisoriamente según lo requerido en
    // https://dev.azure.com/HAL-LMKArgentina/DHO/_workitems/edit/1904
    // this.getWellheadSectionNames();
    // this.getWellheadBottomConnectorTypes();
    // this.getWellheadTopConnectorTypes();
    // if (this.handoverId && this.wellId) {
    //   this.getWellheads(this.handoverId, this.wellId);
    // }
    if (this.handover?.handoverId) {
      this.imageService.endpointUrl = `${environment.urlBackend}/dhoapi/handovers/${this.handover.handoverId}/wellheads/images`;
      this.getWellheadImages(this.handover.handoverId);
      this.canUserEditImages = !this.userService.hasPermission(
        PERMISSION_ENGINEERING_COMPLETION
      );
      if (this.handoverRelation) {
        this.ReadOnlyContentWellheadImages =
          this.handoverRelation.handoverLocationId != null;
      }
    }
    if (
      this.handover?.handoverTypeId == HANDOVER_TYPE_HO1_ID ||
      this.handover?.handoverTypeId == HANDOVER_TYPE_HOEC_ID ||
      this.handover?.handoverTypeId == HANDOVER_TYPE_HOAC_ID
    ) {
      this.displayWellheadHydraulic = true;
      this.getWellheadAttachments();
      this.getWellheadHydraulic();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.handoverRelation && this.handoverRelation) {
      this.isHOLOC =
        this.handoverRelation.handoverLocationId === this.handover?.handoverId;
      if (
        (this.handoverRelation.handoverId === this.handover?.handoverId &&
          this.handoverRelation.handoverLocationId) ||
        (this.handoverRelation.handoverLocationId ===
          this.handover?.handoverId &&
          this.handoverRelation.handoverId)
      )
        this.getRelatedHandoverData();
    }
  }

  getRelatedHandoverData(): void {
    if (this.handover) {
      this.isLoading = true;
      this.handoverService
        .getRelatedHandoverData(this.handover.handoverId!)
        .subscribe((relatedHandover: RelatedHandover) => {
          this.relatedHandover = relatedHandover;
        });
      this.isLoading = false;
    }
  }

  getWellheadSectionNames(): void {
    this.handoverService
      .getWellheadSectionNames()
      .subscribe((values: WellheadSectionName[]) => {
        this.wellheadSectionNames = values;
      });
  }

  getWellheadTopConnectorTypes(): void {
    this.handoverService
      .getWellheadTopConnectorTypes()
      .subscribe((values: WellheadTopConnectorType[]) => {
        this.wellheadTopConnectorTypes = values;
      });
  }

  getWellheadBottomConnectorTypes(): void {
    this.handoverService
      .getWellheadBottomConnectorTypes()
      .subscribe((values: WellheadBottomConnectorType[]) => {
        this.wellheadBottomConnectorTypes = values;
      });
  }

  getWellheads(handoverId: number, wellId: string): void {
    this.isLoading = true;
    this.handoverService
      .getWellheads(handoverId, wellId)
      .subscribe((values: Wellhead[]) => {
        this.wellheads = values;
        this.setOriginalWellheadsValues(values);
        this.isLoading = false;
        this.hideFooter = values.length > 0;
      });
  }

  setOriginalWellheadsValues(values: Wellhead[]): void {
    this.originalWellheads = values.map((value: Wellhead) => {
      this.isDisabled.push(true);
      if (value.comments == null) value.comments = '';
      return Object.assign({ isDisabled: true }, value);
    });
  }

  enableSaveButton(index: number): void {
    const oWh = this.originalWellheads[index];
    const enable =
      this.wellheads[index].sectionNameId != oWh.sectionNameId ||
      this.wellheads[index].topConnectorTypeId != oWh.topConnectorTypeId ||
      this.wellheads[index].bottomConnectorTypeId !=
        oWh.bottomConnectorTypeId ||
      this.wellheads[index].comments != oWh.comments;
    this.isDisabled[index] = !enable;
  }

  openComments(
    wellhead: Wellhead,
    index: number,
    $event: any,
    readOnly: boolean
  ): void {
    const target = new ElementRef($event.currentTarget);
    this.dialogService
      .openCommentDialog(
        'Comentarios',
        this.wellheads[index].comments,
        target,
        -200,
        -450,
        readOnly
      )
      .afterClosed()
      .subscribe((comments: string) => {
        this.wellheads[index].comments = comments;
        this.enableSaveButton(index);
      });
  }

  save(wellhead: Wellhead, index: number): void {
    const dialogRef = this.dialogService.openConfirmDialog(
      'Cabezal',
      '¿Desea guardar los cambios realizados en el Cabezal?'
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        wellhead.handoverId = this.handover?.handoverId;
        const wellheads: Wellhead[] = [];
        wellheads.push(wellhead);

        this.handoverService
          .saveWellheads(wellheads)
          .subscribe((savedWellheads: Wellhead[]) => {
            if (savedWellheads) {
              this.notificationService.notify(
                `Los cambios en el Cabezal se han guardado con éxito.`,
                true
              );
              this.isDisabled[index] = true;
              this.originalWellheads[index].sectionNameId =
                wellhead.sectionNameId;
              this.originalWellheads[index].topConnectorTypeId =
                wellhead.topConnectorTypeId;
              this.originalWellheads[index].bottomConnectorTypeId =
                wellhead.bottomConnectorTypeId;
              this.originalWellheads[index].comments = wellhead.comments;
            } else {
              this.notificationService.notify(
                `Ocurrió un error al grabar los cambios en el Cabezal.`,
                false
              );
            }
          });
      }
    });
  }

  getWellheadHydraulic(): void {
    this.isLoading = true;
    if (!this.handover?.handoverId) return;
    this.handoverService
      .getWellheadHydraulic(this.handover.handoverId)
      .subscribe((wellheadHydraulic) => {
        this.wellheadHydraulic.masterValve =
          wellheadHydraulic.masterValve == null
            ? undefined
            : wellheadHydraulic.masterValve;
        this.wellheadHydraulic.valveOverMaster =
          wellheadHydraulic.valveOverMaster == null
            ? undefined
            : wellheadHydraulic.valveOverMaster;
        if (this.wellheadHydraulic.masterValve)
          this.formHydraulic.controls['masterValve'].setValue(
            wellheadHydraulic.masterValve
          );
        if (this.wellheadHydraulic.valveOverMaster)
          this.formHydraulic.controls['valveOverMaster'].setValue(
            wellheadHydraulic.valveOverMaster
          );
      });
    this.isLoading = false;
  }

  saveWellheadHydraulic(): void {
    const dialogRef = this.dialogService.openConfirmDialog(
      'Cabezal',
      '¿Desea guardar los cambios realizados en el Cabezal?'
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res && this.handover?.handoverId) {
        if (this.formHydraulic.value.masterValve != '')
          this.wellheadHydraulic.masterValve = Number(
            this.formHydraulic.value.masterValve
          );
        else this.wellheadHydraulic.masterValve = undefined;
        if (this.formHydraulic.value.valveOverMaster != '')
          this.wellheadHydraulic.valveOverMaster = Number(
            this.formHydraulic.value.valveOverMaster
          );
        else this.wellheadHydraulic.valveOverMaster = undefined;
        this.handoverService
          .saveWellheadHydraulic(
            this.handover?.handoverId,
            this.wellheadHydraulic
          )
          .subscribe((savedWellheadHydraulic: WellheadHydraulic) => {
            if (savedWellheadHydraulic) {
              this.hydraulicHasPendingChanges = false;
              this.reportPendingChanges();
              this.notificationService.notify(
                `Los cambios en el Cabezal se han guardado con éxito.`,
                true
              );
            } else {
              this.notificationService.notify(
                `Ocurrió un error al grabar los cambios en el Cabezal.`,
                false
              );
            }
          });
      }
    });
  }

  onChangeWellheadHydraulic(): void {
    this.hydraulicHasPendingChanges = !this.wellheadHydraulicValuesAreEqual(
      this.wellheadHydraulic,
      this.formHydraulic.value
    );
    this.reportPendingChanges();
  }

  onSchemePendingChanges(hasPendingChanges: boolean): void {
    this.schemeHasPendingChanges = hasPendingChanges;
    this.reportPendingChanges();
  }

  /**
   * La pantalla tiene dos orígenes de cambios pendientes (Prueba Hidráulica y
   * Esquema de Cabezal); si cada uno emitiera por su cuenta, el último en
   * hablar pisaría al otro.
   */
  reportPendingChanges(): void {
    this.emitPendingChanges(
      this.hydraulicHasPendingChanges || this.schemeHasPendingChanges
    );
  }

  wellheadHydraulicValuesAreEqual(
    value1: WellheadHydraulic,
    value2: any
  ): boolean {
    return (
      value1.masterValve ===
        (value2.masterValve != '' ? Number(value2.masterValve) : undefined) &&
      value1.valveOverMaster ===
        (value2.valveOverMaster != ''
          ? Number(value2.valveOverMaster)
          : undefined)
    );
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (this.handover?.handoverId && file) {
      this.isLoading = true;
      const formData = new FormData();
      formData.append('file', file);
      this.handoverService
        .saveWellheadAttachment(this.handover.handoverId, formData)
        .subscribe(
          (uploaded: WellheadAttachment[]) => {
            if (uploaded) {
              this.uploadfile = true;
              this.getWellheadAttachments();
            }
          },
          (response: HttpErrorResponse) => {
            this.notificationService.notify(response.error.message, false);
          }
        );
      this.isLoading = false;
    }
  }

  getWellheadAttachments(): void {
    if (this.handover?.handoverId) {
      this.handoverService
        .getWellheadAttachments(this.handover.handoverId)
        .subscribe((file: WellheadAttachment[]) => {
          if (file) {
            this.wellheadAttachment = file;
            this.buttonFile = true;
            this.uploadfile = true;
          }
        });
    }
  }

  deleteWellheadAttachment(file: any): void {
    const dialogRef = this.dialogService.openConfirmDialog(
      'Cabezal',
      `¿Está seguro de que desea eliminar el archivo?`
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        if (!this.handover?.handoverId) {
          return;
        }
        this.isLoading = true;
        this.handoverService
          .deleteWellheadAttachment(this.handover.handoverId, file)
          .subscribe((res: boolean) => {
            if (res) {
              delete this.wellheadAttachment;
              this.getWellheadAttachments();
            }
            this.isLoading = false;
          });
      }
    });
  }

  attachImage(): void {
    if (this.handover?.handoverId) {
      const dialogRef = this.dialogService.openImageUploadDialog(
        this.handover.handoverId,
        'Adjuntar foto o diagrama',
        500
      );
      dialogRef.afterClosed().subscribe((image) => {
        if (undefined != image) {
          this.wellheadImages.push(image);
        }
      });
    }
  }

  getWellheadImages(handoverId: number): void {
    this.isLoadingImages = true;
    this.handoverService
      .getWellheadImages(
        this.handoverRelation && this.handoverRelation.handoverLocationId
          ? this.handoverRelation.handoverLocationId
          : this.handover!.handoverId!
      )
      .subscribe((values: Image[]) => {
        this.wellheadImages = values;
        this.isLoadingImages = false;
      });
  }

  deleteImage(image: Image, index: number): void {
    const dialogRef = this.dialogService.openConfirmDialog(
      'Cabezal',
      `¿Está seguro de que desea eliminar la imagen?`
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.isLoadingImages = true;
        this.imageService.deleteImage(image).subscribe((boolean) => {
          this.wellheadImages.splice(index, 1);
          this.isLoadingImages = false;
        });
      }
    });
  }

  openImage(image: Image): void {
    const dialogRef = this.dialog.open(HandoverImageComponent, {
      width: '700px',
      height: '600px',
      hasBackdrop: false,
      autoFocus: false,
      data: {
        image: image,
        title: 'Cabezal',
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      console.log('Datos generales de pozo ha sido cerrado');
    });
  }
}
